/**
 * WordPress dependencies
 */
import { BaseControl, Button, ColorIndicator, ColorPicker, Flex, FlexBlock, FlexItem, Popover } from '@wordpress/components';
import { withInstanceId } from '@wordpress/compose';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import classNames from 'classnames';

/**
 * Internal dependencies
 */

const ColorControl = ({ label, color, onChange, instanceId }) => {
    const [colorPanel, setColorPanel] = useState(false);

    const id = `color-control-${instanceId}`;

    // get colors from theme
    const COLORS = wp.data.select('core/editor').getEditorSettings().colors;

    return (
        <div className="faqmate-control-container faqmate-color-control faqmate-mb-0">
            <Flex>
                <FlexBlock>
                    <BaseControl id={id} label={label} />
                </FlexBlock>
                <FlexItem>
                    <Button
                        icon="image-rotate"
                        label={__('Reset', 'faqmate-blocks')}
                        onClick={() => onChange('')}
                        className={`faqmate-reset-button ${color ? 'active' : 'disabled'}`}
                    />
                </FlexItem>
                <FlexItem>
                    <button className="color-indicator" onClick={() => setColorPanel(true)}>
                        <ColorIndicator colorValue={color} />
                    </button>
                    {colorPanel && (
                        <Popover position="bottom right" onFocusOutside={() => setColorPanel(false)} offset={10}>
                            <div className="faqmate-color-panel">
                                <ColorPicker color={color} onChangeComplete={value => onChange(value.hex)} disableAlpha={false} />
                                <div className="faqmate-colors-palette">
                                    <label className="faqmate-label faqmate-mb-8" htmlFor="faqmate-colors-palette">
                                        {__('Theme Colors', 'faqmate-blocks')}
                                    </label>
                                    <div id="faqmate-colors-palette">
                                        {COLORS &&
                                            COLORS.map((paletteColor, index) => {
                                                return (
                                                    <ColorIndicator
                                                        className={classNames(
                                                            'faqmate-color-indicator',
                                                            `${color === `var(--wp--preset--color--${paletteColor.slug})` ? 'active' : ''}`
                                                        )}
                                                        title={paletteColor.name}
                                                        key={index}
                                                        colorValue={paletteColor.color}
                                                        onClick={() => onChange(`var(--wp--preset--color--${paletteColor.slug})`)}
                                                    />
                                                );
                                            })}
                                    </div>
                                </div>
                            </div>
                        </Popover>
                    )}
                </FlexItem>
            </Flex>
        </div>
    );
};

export default withInstanceId(ColorControl);
